import { styled } from '@mui/material/styles'
import SvgIcon from '@mui/material/SvgIcon'
import { useEffect } from 'react'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

const NudgeWithIconContainer = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  padding: theme.spacing(2),
  borderRadius: theme.spacing(0.5),
  boxShadow: `0px 2px ${theme.spacing(2)} ${theme.palette.grey[100]}`,
  borderLeft: `${theme.spacing(1)} solid ${theme.palette.primary.main}`,
  fontSize: '12px',
  lineHeight: '20px'
}))

export interface NudgeWithIconProps {
  text: string | React.ReactElement
  Icon: typeof SvgIcon
  customIcon?: string
}

export const NudgeWithIcon: React.FC<NudgeWithIconProps> = ({
  text,
  Icon,
  customIcon
}) => {
  useEffect(() => {
    trackInAmplitude(AmplitudeEvent.NudgeIsVisible, {
      nudgeText: typeof text === 'string' ? text : '[ReactElement]'
    })
  }, [])
  return (
    <NudgeWithIconContainer>
      {customIcon ? (
        <img alt="icon" src={customIcon} />
      ) : (
        <Icon color="primary" />
      )}
      {text}
    </NudgeWithIconContainer>
  )
}
